/**
 * The WIRE name of "Replace" (owner, 2026-10-06: Replace writes a new VERSION into the existing file).
 *
 * Rolling deploy (Codex round): an API process from before Replace-as-version reads `replace` as
 * bin-and-create. A browser on the new SPA must not reach one with `replace` and get the old behaviour,
 * so new clients send `replaceVersion`, a value an old process never reads as Replace (copy / extract /
 * tus reject it; cross-tenant copy keeps both; an old WORKER handed a job by a new API keeps both or
 * versions). New servers accept `replace`, its legacy name `addVersion` and `replaceVersion`, all as
 * version-in-place: job payloads carry the wire value unchanged and the code that ACTS on it normalises
 * with {@link fromWireConflictStrategy}. The bin-and-create `replaceAsNew` stays INTERNAL.
 */
export const REPLACE_VERSION_WIRE = 'replaceVersion' as const

/** Client → wire: `replace` goes out as `replaceVersion`; anything else unchanged. */
export function toWireConflictStrategy<T extends string | undefined>(s: T): T | typeof REPLACE_VERSION_WIRE {
  return (s === 'replace' ? REPLACE_VERSION_WIRE : s) as T | typeof REPLACE_VERSION_WIRE
}

/** Wire → server: `replaceVersion` is `replace` (version-in-place); anything else unchanged. */
export function fromWireConflictStrategy<T extends string | undefined>(s: T): Exclude<T, typeof REPLACE_VERSION_WIRE> | 'replace' {
  return (s === REPLACE_VERSION_WIRE ? 'replace' : s) as Exclude<T, typeof REPLACE_VERSION_WIRE> | 'replace'
}
